import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';
import { UtilesService } from './utiles.service';
import { TryCatchStmt } from '@angular/compiler';

import { Compania } from '../Models/Compania';

@Injectable()
export class CompaniaService {

  constructor(
    private _http: Http,
    private _utiles: UtilesService

  ) { }

  /**
   * Obtiene la informacion de la compañia
   * @param compania Codigo de la compañia
   */
  ObtenerCompania(compania: string): Observable<Compania> {

    try {

      let url = this._utiles.getURL("compania/" + compania);

      return this._http.get(url).map((response: Response) => {
        return <Compania>response.json();
      });

    } catch (error) {

      console.log(error);
    }

  }
  /**
   * Guarda el registro de la conpañia
   * @param compania Codigo de la compañia
   */
  public GuardarRegistro(compania: Compania) {

    try {

      let params = JSON.stringify(compania);

      let url = this._utiles.getURL("compania/");

      let headers = new Headers({ 'Content-Type': 'application/json' });

      let data: any;

      return this._http.post(url, compania, { headers: headers }).subscribe(res => {
        data = res;
      });

    } catch (error) {
      console.log(error);
    }


  }

}
